import { writable } from 'svelte/store'

import { browser } from '$app/environment'
import { apiFetchJson } from '$lib/proxy/apiProxy'

import { type OpenaiThreadItem } from '../openai_thread_item/types'



const store = writable([] as OpenaiThreadItem[])

export { store as openai_thread_items_store }



let promiseFetch: Promise<OpenaiThreadItem[]>
let state: 'pending' | 'reading' | 'ready' = 'pending'

export const InitOpenaiThreadItems = async (openai_thread_id: string, pFetch = fetch, force = false) => {
	// if SSR just return the promise data
	if (!browser) return fetchData(openai_thread_id, pFetch)
	if (openai_thread_id==='') {
		console.log('init openai thread items: empty thread id')
		store.set([])
		return true
	}

	if (!force && state === 'ready') return
	if (!force && state === 'reading') {
		await promiseFetch
		return true
	}

	promiseFetch = fetchData(openai_thread_id, pFetch)
	await promiseFetch
	return true
}

const fetchData = async (openai_thread_id: string, pFetch = fetch) => {
	if (browser) state = 'reading'

	const params = { openai_thread_id: openai_thread_id }
	const body = JSON.stringify(params)
	const jsonData = await apiFetchJson(pFetch, 'post', 
		'/openai_thread_items', undefined, body)
	if (!jsonData || jsonData.error) {
		if (browser) state = 'pending'
		return []
	}

	// const data = parseServer(jsonData)
	const data = jsonData.openai_thread_items
	if (browser) {
		store.set(data)
		state = 'ready'
	}


	return data
}
